// test2189
(2189 && 0);
